export const config = {
  title: "Space Age Electric (OSHAWA) Limited | Trusted Electricians in Oshawa, ON",
  meta: {
    description:
      "Space Age Electric (OSHAWA) Limited delivers expert residential, commercial, and industrial electrical solutions across Oshawa, Ontario and surrounding areas.",
    keywords: [
      "Space Age Electric",
      "electricians Oshawa",
      "commercial electrical services Ontario",
      "industrial electricians Canada",
      "residential wiring Oshawa"
    ],
    author: "Space Age Electric (OSHAWA) Limited",
    canonicalUrl: "https://spaceageelectric.com/",
  },
  sections: {
    header: {
      businessName: "Space Age Electric (OSHAWA) Limited",
    },
    sectionB: {
      heroTitle: "Space Age Electric (OSHAWA) Limited",
      heroSubtitle: "Reliable Residential & Commercial Electricians in Oshawa, ON",
      learnAboutText: "Request a Quote",
      phoneNumber: "9054366744",
      phoneLabel: "(905) 436-6744",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2151912560/photo/electrician-installing-a-power-outlet-while-remodeling-a-house.jpg?s=612x612&w=0&k=20&c=2xpWucgxxlWFRIzNyxlww5-_toizKTr_WaOztmtASqA=",
      cardData: [
        {
          title: "Residential Electrical",
          description: "Safe and efficient wiring, installations, and repairs for your home.",
        },
        {
          title: "Commercial Projects",
          description: "Powering businesses with expert commercial electrical solutions.",
        },
        {
          title: "Industrial Services",
          description: "Heavy-duty electrical systems for industrial environments.",
        },
      ],
      description:
        "Serving Oshawa and the Greater Toronto Area, Space Age Electric (OSHAWA) Limited provides reliable electrical services backed by decades of experience in residential, commercial, and industrial sectors.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From simple home rewiring to complex industrial systems, we have you covered.",
      cards: [
        {
          title: "Panel Upgrades & Rewiring",
          description: "Ensure your electrical system is safe and code-compliant.",
          imageSrc: "https://media.istockphoto.com/id/958976246/photo/electrician-upgrading-a-homes-distribution-board.jpg?s=612x612&w=0&k=20&c=Un7PWttvvBeI-QQWFuJA8gLsJothZc8oYsE8ODpedxs=",
          imageAlt: "Panel upgrades",
        },
        {
          title: "Lighting Design & Installation",
          description: "Brighten your space with efficient, custom lighting.",
          imageSrc: "https://media.istockphoto.com/id/2183902313/photo/installing-led-strips-for-modern-lighting-solutions-in-residential-and-commercial-spaces.jpg?s=612x612&w=0&k=20&c=tfqsYDXQULCvyaa4dsZL1g7dFasPzy7gIJrH1LPh6dA=",
          imageAlt: "Lighting installation",
        },
        {
          title: "Troubleshooting & Repairs",
          description: "Diagnose and resolve any electrical issues quickly.",
          imageSrc: "https://media.istockphoto.com/id/2153346173/photo/one-man-repair-gas-boiler-with-wrenches-gas-heating-boiler-service-at-home.jpg?s=612x612&w=0&k=20&c=6gc9x0QvaIZhE4OvQYVs5KJ2ryPKzLLmZcYJrHQAsqM=",
          imageAlt: "Electrical troubleshooting",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Over 25 Years of Experience",
        "Fully Licensed & Insured",
        "Competitive Pricing",
        "Fast Emergency Response",
        "Trusted by Hundreds of Clients",
      ],
    },
    sectionD: {
      aboutTitle: "About Space Age Electric",
      aboutImage: {
        src: "https://img1.wsimg.com/isteam/getty/1263134450/:/cr=t:0%25,l:16.66%25,w:66.68%25,h:100%25/rs=w:600,h:600,cg:true",
        alt: "Space Age Electric Logo",
      },
      aboutText: [
        "At Space Age Electric (OSHAWA) Limited, we specialize in providing high-quality electrical services across Ontario.",
        "Our team is dedicated to safety, precision, and delivering results that exceed expectations—whether it's a new build, renovation, or emergency service.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Space Age Electric Logo",
      businessName: "Space Age Electric (OSHAWA) Limited",
      contact: {
        phone: "9054366744",
        phoneLabel: "(905) 436-6744",
        email: "robertpalermospaceage@gmail.com",
        website: "https://spaceageelectric.com/",
        address: "219 Bloor Street East, Oshawa, ON, Canada",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "219 Bloor Street East, Oshawa, ON, Canada",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2887.1267749822726!2d-78.8481149!3d43.8877612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d507f2f737fbc9%3A0x3168cc8e1957c4b1!2s219%20Bloor%20St%20E%2C%20Oshawa%2C%20ON%20L1H%203M3%2C%20Canada!5e0!3m2!1sen!2sca!4v1710000000000",
    },
  },
};

export default config;
